class NewsletterPopup extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.dialog = this.querySelector('.nl-popup__dialog');
    this.storageKey = this.dataset.storageKey || 'oxylythe-nl-popup';
    const delay = Number(this.dataset.delay || 5000);
    const designMode = Boolean(window.Shopify && Shopify.designMode);
    const posted = this.hasAttribute('data-posted');

    this.querySelector('.nl-popup__close')?.addEventListener('click', () => this.close(true));
    this.querySelector('.nl-popup__overlay')?.addEventListener('click', () => this.close(false));
    this.addEventListener('click', (event) => {
      if (event.target === this) this.close(false);
    });

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close(false);
    });

    if (designMode) {
      this.open();
      return;
    }

    if (!posted && window.localStorage.getItem(this.storageKey)) return;

    window.setTimeout(() => this.open(), posted ? 0 : delay);
  }

  open() {
    if (this.hasAttribute('open')) return;
    this.setAttribute('open', '');
    this.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden');
    const closeButton = this.querySelector('.nl-popup__close');
    const focusTarget = this.querySelector('input:not([type="hidden"])') || closeButton;
    if (typeof trapFocus === 'function') {
      trapFocus(this.dialog, focusTarget);
    } else if (focusTarget) {
      focusTarget.focus();
    }
  }

  close(persist) {
    if (!this.hasAttribute('open')) return;
    this.removeAttribute('open');
    this.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    if (persist && !(window.Shopify && Shopify.designMode)) {
      try {
        window.localStorage.setItem(this.storageKey, '1');
      } catch (error) {
        // Ignore private-mode quota errors.
      }
    }
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
